import classNames from 'classnames';

import { useAnchorable } from '../../hooks/useAnchorable';

import { htmlSnippet } from './HTMLSnippet.css';
import type { TPostHTMLSnippetProps } from './HTMLSnippet.types';

export const PostHTMLSnippet = (props: TPostHTMLSnippetProps) => {
  const { element } = props;
  const { attrs } = element;

  const { anchorAttributes } = useAnchorable(attrs);

  if (!attrs?.data?.html) {
    return null;
  }

  return (
    <div
      {...anchorAttributes}
      className={classNames(htmlSnippet, props.className)}
      dangerouslySetInnerHTML={{ __html: attrs.data.html }}
    />
  );
};
